import gsap from "gsap";
import { Linear } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const textWithimg = () => {
    const textWithImg = document.querySelectorAll('.text-with-img');
    const tl = gsap.timeline({
        defaults: {
            ease: Linear.ease,
        }
    });

    ScrollTrigger.defaults({
        start: 'top 100%',
        end: 'top 20%',
        scrub: true,
    });

    gsap.matchMedia().add(
        "(min-width: 900px)", () => {
            textWithImg.forEach(e => {
                tl.to(e.querySelector('figure'), {
                    scrollTrigger: {
                        trigger: e.querySelector('figure')
                    },
                    rotate: 0
                }).from(e.querySelector('.btn'), {
                    scrollTrigger: {
                        trigger: e.querySelector('.btn'),
                        start: 'top +=120%',
                        end: 'top 90%'
                    },
                    y: '8rem'
                }, '<').from(e.querySelector('.text-with-img__text'), {
                    scrollTrigger: {
                        trigger: e.querySelector('.text-with-img__text')
                    },
                    y: '8rem'
                }, '<')
            });
        }
    )
}

export const textWithImgAndHeading = () => {
    const textWithImg = document.querySelectorAll('.text-with-img-and-heading');
    const tl = gsap.timeline({
        defaults: {
            ease: Linear.ease,
        }
    });

    ScrollTrigger.defaults({
        start: 'top 100%',
        end: 'top 20%',
        scrub: true,
    });

    gsap.matchMedia().add(
        "(min-width: 900px)", () => {
            textWithImg.forEach(e => {
                tl.from(e.querySelector('figure'), {
                    scrollTrigger: {
                        trigger: e.querySelector('figure')
                    },
                    rotate: '5deg'
                }).from(e.querySelector('.text-with-img-and-heading__content'), {
                    scrollTrigger: {
                        trigger: e.querySelector('.text-with-img-and-heading__content')
                    },
                    y: '8rem'
                }, '<')
            });
        }
    )
}